import React from 'react';
import styles from './InfoModal.module.scss';
import Modal from 'react-bootstrap/Modal';

export type infoModalProps = {
  /**
   * if the modal shows or not
   */
  visibility: boolean;
  /**
   * onChange function to control visibility of the modal
   */
  setShow: any;
  /**
   * object with the text contents of the modal
   */
  modalData: any;
};

const InfoModal = ({ visibility, setShow, modalData }: infoModalProps) => {
  const handleClose = () => setShow(false);
  return (
    <div className={styles.InfoModal} data-testid="InfoModal">
      <Modal show={visibility}>
        <Modal.Header closeButton onClick={handleClose}>
          <Modal.Title>
            {modalData.type}: {modalData.code}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{modalData.message}</p>
          <p>
            If you are experiencing any challenges,
            please feel free to <a href="https://drive.google.com/drive/folders/1LVWwHeFv6_jryRneFxWeBi30wTEbAwOD and update the verbiage to">
              download a copy of your timesheet
            </a> here and submit to
            edutimesheets@ccrn.com as soon as possible to ensure you are paid on time.
          </p>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
};

export default InfoModal;
